import React from "react";
import { YhBox } from "@/components/YhBox";
import { SearchItem } from "@/components/YhPageHeader/item";
import { Row } from "antd";
import { ISearchField, ISearchProp, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { useDetailModel } from "../detailModel";
import { useBillModel } from "./billModel";
import { billStatusDs, ioFlagDs, tradeTypeDs, billCancelStatusDs } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";

export const BIllSearchBox = () => {

    const { customerUserDs } = useDetailModel()
    const { unit, user: { shopCode } } = useGlobalModel()

    const {
        onSearch,
        searchParam,
        onReset,
        updateSearchParam,
        loadData
    } = useBillModel()


    const searchProp: ISearchProp = {
        searchValues: searchParam,
        triggerSearch: true,
        handleSearch: (val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val }),
        onChange: (data) => {
            updateSearchParam(data)
        }
    }
    const searchFields: (ISearchProp & ISearchField)[] = [
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "交易方向",
            fieldName: "direction",
            size: "small",
            disabled: false,
            options: [{
                label: '调入',
                value: 'IN'
            }, {
                label: '调出',
                value: 'OUT'
            }],
            searchValues: searchParam,
            triggerSearch: true,
            onChange: (data) => {
                let newData = {
                    shopCode: undefined,
                    outShopCode: undefined,
                    ...data
                } as any
                if (data.direction === 'IN') {
                    newData.shopCode = shopCode
                } else if (data.direction === 'OUT') {
                    newData.outShopCode = shopCode
                }
                updateSearchParam(newData)
                loadData({ pageNum: 1 }, { ...searchParam, ...newData })
            }
        },
        // {
        //     type: SearchTypeEnum.Select,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "核算单位",
        //     fieldName: "unitCode",
        //     size: "small",
        //     disabled: false,
        //     options: [],
        //     ...searchProp
        // },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "账户名称",
            fieldName: "accountCode",
            options: customerUserDs?.filter(item => item.unitCode === unit?.code),
            size: "small",
            disabled: false,
            ...searchProp
        },
        // {
        //     type: SearchTypeEnum.Input,
        //     xxl: 4,
        //     span: 4,
        //     placeholder: "交易编码",
        //     fieldName: "",
        //     size: "small",
        //     disabled: false,
        //     ...searchProp
        // },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "单据编码",
            fieldName: "code",
            size: "small",
            disabled: false,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Select,
            xxl: 4,
            span: 4,
            placeholder: "收款状态",
            fieldName: "payStatus",
            size: "small",
            disabled: false,
            options: billStatusDs,
            ...searchProp
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "检索",
            fieldName: "searchButton",
            onClick: onSearch,
        },
        {
            type: SearchTypeEnum.Button,
            xxl: 2,
            span: 2,
            placeholder: "重置",
            fieldName: "searchButton",
            onClick: onReset
        },
        {
            type: SearchTypeEnum.RangePicker,
            xxl: 8,
            span: 8,
            placeholder: "起止",
            fieldName: "time",
            size: "small",
            disabled: false,
            searchValues: searchParam,
            triggerSearch: true,
            onChange: (data) => {
                let newData = data.time[0] !== '' && data.time[1] !== '' ? {
                    startTime: data.time[0] + ' 00:00:00',
                    endTime: data.time[1] + ' 23:59:59',
                    ...data
                } : {
                    startTime: undefined,
                    endTime: undefined,
                    ...data
                }
                updateSearchParam(newData)
                loadData({ pageNum: 1 }, { ...searchParam, ...newData })
            }
        },

    ]

    return (
        <YhBox>
            <Row
                gutter={[20, 10]}
                justify="start"
                style={{ padding: "0 15px" }}
            >
                {searchFields?.map(
                    (el, index) => <SearchItem
                        key={index}
                        {...el} />
                )}
            </Row>
        </YhBox>
    )
}
